export default __webpack_public_path__ + "static/media/021-asparagus.1a9718bd.svg";